// Thème Maison : texte replié avec « Voir plus / Voir moins ».
// Le nombre de lignes visibles est réglé en CSS (variables --mx-lines et --mx-lines-desktop) ;
// ce script affiche le bouton seulement si le texte dépasse, et anime l'ouverture.

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

class MxTextMore extends HTMLElement {
  /** @type {HTMLElement | null} */
  #content = null;
  /** @type {HTMLButtonElement | null} */
  #button = null;
  /** @type {ResizeObserver | undefined} */
  #observer;
  /** @type {Animation | undefined} */
  #animation;
  #expanded = false;

  connectedCallback() {
    this.#content = this.querySelector('[data-mx-content]');
    const button = this.querySelector('[data-mx-toggle]');
    this.#button = button instanceof HTMLButtonElement ? button : null;
    if (!this.#content || !this.#button) return;

    this.#button.addEventListener('click', this.#toggle);
    this.#observer = new ResizeObserver(() => this.#measure());
    this.#observer.observe(this.#content);
    this.#measure();
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#toggle);
    this.#observer?.disconnect();
  }

  /** Affiche le bouton seulement si le texte est plus long que la zone visible. */
  #measure() {
    if (!this.#content || !this.#button || this.#expanded) return;
    const overflowing = this.#content.scrollHeight > this.#content.clientHeight + 2;
    this.toggleAttribute('data-overflowing', overflowing);
    this.#button.hidden = !overflowing;
  }

  /**
   * @param {number} from
   * @param {number} to
   */
  #animate(from, to) {
    if (!this.#content || reducedMotion.matches) return;
    this.#animation?.cancel();
    this.#content.style.overflow = 'hidden';
    this.#animation = this.#content.animate({ height: [`${from}px`, `${to}px`] }, { duration: 280, easing: 'ease-in-out' });
    this.#animation.onfinish = () => {
      if (this.#content) this.#content.style.overflow = '';
    };
  }

  #toggle = () => {
    const content = this.#content;
    const button = this.#button;
    if (!content || !button) return;

    const start = content.offsetHeight;
    this.#expanded = !this.#expanded;
    this.toggleAttribute('data-expanded', this.#expanded);
    button.setAttribute('aria-expanded', String(this.#expanded));

    const label = button.querySelector('[data-mx-label]');
    if (label) label.textContent = (this.#expanded ? this.dataset.lessLabel : this.dataset.moreLabel) ?? '';

    const end = this.#expanded ? content.scrollHeight : content.offsetHeight;
    this.#animate(start, end);

    if (!this.#expanded && this.getBoundingClientRect().top < 0) {
      this.scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }
  };
}

if (!customElements.get('mx-text-more')) {
  customElements.define('mx-text-more', MxTextMore);
}
